import { render, staticRenderFns } from "./view.html?vue&type=template&id=41cf6dbf&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=41cf6dbf&lang=less&scoped=true&"
import style1 from "./style_common.less?vue&type=style&index=1&lang=less&"
import style2 from "./style_mobile.less?vue&type=style&index=2&id=41cf6dbf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cf6dbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41cf6dbf')) {
      api.createRecord('41cf6dbf', component.options)
    } else {
      api.reload('41cf6dbf', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=41cf6dbf&scoped=true&", function () {
      api.rerender('41cf6dbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battle/index.vue"
export default component.exports